import { IAppBillingFeatures, IAppBillingPlan } from '../../core/interfaces/IBillingPlan.js';
import billingPlans from './billing-plans.json';

export const planFeatures: {
  featureList: IAppBillingFeatures[];
  plans: IAppBillingPlan[];
} = billingPlans;
